// Loading
document.addEventListener('DOMContentLoaded', function() {
    const video = document.getElementById('movie')
    const loadingWp = document.getElementById('loading')
    const kvTxt = document.getElementsByClassName('p-kv_txt_svg')
    function loaderClose(){
        loadingWp.classList.add('__loaded')
        for(let i = 0; i<kvTxt.length; i++){
            (function(i){
                setTimeout(function(){
                    kvTxt[i].classList.add('__loaded')
                }, i*100)
            })(i)
        }
        if(video === null){

        }else{
            video.play()
        }
    }
    setTimeout(loaderClose, 1000)
})

// Background Animation
import { Gradient } from './include/Gradient.js'
const gradient = new Gradient()
gradient.initGradient('#gradient-canvas')

// Hamburger Nav
const btnNav = document.getElementById('btnNav')
const nav = document.getElementById('nav')

btnNav.addEventListener('click', event => {
    btnNav.classList.toggle('__open')
    nav.classList.toggle('__open')
})

const navLink = document.getElementsByClassName('p-gnav_item')
Array.from(navLink).forEach(element => {
    element.addEventListener('click', event => {
        btnNav.classList.toggle('__open')
        nav.classList.toggle('__open')
    })
});